import { Modal } from "react-bootstrap";

export default class ModalGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal: this.props.showModal,
    };
  }

  handleHide() {
    this.setState({ showModal: false });
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  render() {
    return (
      <div id="modal-wrap-alert-modal">
        <div className="modal-container">
          <Modal
            show={this.state.showModal}
            container={this.props.container}
            onHide={this.handleHide}
            bsSize="large"
            backdrop="static"
            aria-labelledby="contained-modal-title-lg"
          >
            <Modal.Header>
              <Modal.Title>{this.props.MessageTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 modal-error-body">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                  {this.props.msg}
                </div>
              </div>
              <div className="inner-Model-buttons">
                {this.props.MainButtonText ? (
                  <Button
                    className={
                      this.props.NoAceptar + " btn btn-primary btn-si btn-left"
                    }
                    onClick={() => {
                      this.handleHide();
                      this.props.MainButtonAction();
                    }}
                  >
                    {this.props.MainButtonText}
                  </Button>
                ) : null}
                <Button
                  className={
                    this.props.NoCancelar + " btn btn-default btn-no btn-right"
                  }
                  onClick={() => {
                    this.handleHide();
                    this.props.AltButtonAction();
                  }}
                >
                  {this.props.AltButtonText}
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

// const Modal = ReactBootstrap.Modal;
const Button = ReactBootstrap.Button;
